import { TFunction } from 'react-i18next';
import {
  ProductsListContainer,
  ProductDetailsMainInfoContainer,
  ProductDetailsCharacteristicsContainer,
  ProductDetailsSeoContainer,
  ProductDetailsVariationsContainer,
  ProductDetailsRegionsAndPricesContainer,
  ProductOfMonthContainer,
  TopProductsContainer,
} from '../containers';

export enum ProductsTabs {
  PRODUCTS = 'products',
  PRODUCTS_OF_MONTH = 'products_of_month',
  TOP_PRODUCTS = 'top_products',
  // TODO: temporary hidden, uncomment or remove in future
  // SELECTIONS = 'selections',
}

export enum ProductDetailsTabs {
  MAIN_INFO = 'main_info',
  CHARACTERISTICS = 'characteristics',
  SEO = 'seo',
  PRODUCT_VARIATIONS = 'product_variations',
  REGIONS_AND_PRICES = 'regions_and_prices',
}

export interface IProductTabContentProps {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: () => void;
  clearUnsavedChanges: () => void;
  pendingTab: ProductDetailsTabs | null;
  handleConfirmTabSwitch: () => void;
  handleDeclineTabSwitch: () => void;
  onNavigateToTab: (tab: ProductDetailsTabs) => void;
}

export const getProductsTabsConfig = (t: TFunction) => [
  {
    label: t('products_tab_title'),
    key: ProductsTabs.PRODUCTS,
    content: <ProductsListContainer />,
  },
  {
    label: t('products_of_month_tab_title'),
    key: ProductsTabs.PRODUCTS_OF_MONTH,
    content: <ProductOfMonthContainer />,
  },
  {
    label: t('products_top_tab_title'),
    key: ProductsTabs.TOP_PRODUCTS,
    content: <TopProductsContainer />,
  },
  // TODO: temporary hidden, uncomment or remove in future
  // {
  //   label: t('products_selections_tab_title'),
  //   key: ProductsTabs.SELECTIONS,
  //   content: <>{t('products_selections_tab_title')}</>,
  // },
];

export const getProductDetailsTabsConfig = (t: TFunction) => [
  {
    label: t('main_info_tab_title'),
    key: ProductDetailsTabs.MAIN_INFO,
    content: (props: IProductTabContentProps) => <ProductDetailsMainInfoContainer {...props} />,
  },
  {
    label: t('characteristics_tab_title'),
    key: ProductDetailsTabs.CHARACTERISTICS,
    content: (props: IProductTabContentProps) => <ProductDetailsCharacteristicsContainer {...props} />,
  },
  {
    label: t('seo_tab_title'),
    key: ProductDetailsTabs.SEO,
    content: (props: IProductTabContentProps) => <ProductDetailsSeoContainer {...props} />,
  },
  {
    label: t('product_variations_tab_title'),
    key: ProductDetailsTabs.PRODUCT_VARIATIONS,
    content: () => <ProductDetailsVariationsContainer />,
  },
  {
    label: t('regions_and_prices_tab_title'),
    key: ProductDetailsTabs.REGIONS_AND_PRICES,
    content: () => <ProductDetailsRegionsAndPricesContainer />,
  },
];

export interface PhotoItem {
  uid: string;
  name: string;
  order: number;
  isServerPhoto: boolean;
  originalUrl?: string;
  originFileObj?: File;
}
